import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_static/legal-notice')({
	component: LegalNoticePage,
});

function LegalNoticePage() {
	const { t } = useTranslation();
	return <h1>{t('staticPages.legalNotice.title')}</h1>;
}
